import React, { Component } from "react";
import { toast } from "react-toastify";
import { PiCopy } from "react-icons/pi";
import { IoInformation } from "react-icons/io5";
import { Modal, Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "../../axios";
import apiError from "../../error";
import Loader from "../../component/loader/loader";
import "../../container/landing-url/landing-url-edit/landing-edit.css";

export default class VerifyDomain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domainName: "",
            ns1: "",
            ns2: "",
            originalNS: [],
            loading: false,
            copiedId: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && this.props.urlId && (this.props.show !== prevProps.show || this.props.urlId !== prevProps.urlId)) {
            this.load();
        }
    }

    load = () => {
        const urlId = this.props.urlId;
        if (!urlId) return;
        this.setState({ loading: true });
        axios
            .get(`/api/pages/url/${urlId}`, {})
            .then((res) => {
                this.setState({
                    loading: false,
                    domainName: res.data.domainName || "",
                    ns1: res.data.ns1 || "",
                    ns2: res.data.ns2 || "",
                    originalNS: res.data.originalNS || [],
                });
            })
            .catch((err) => {
                apiError(err);
                this.setState({ loading: false });
            });
    };

    handleCopy = (id, content) => {
        const el = document.createElement("textarea");
        el.value = content;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        this.setState({ copiedId: id });
        setTimeout(() => this.setState({ copiedId: null }), 1000);
    };

    verifyDomain = () => {
        const urlId = this.props.urlId;
        if (!urlId) return;
        this.setState({ loading: true });
        axios
            .get(`/api/pages/validate/${urlId}`, {})
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.status) {
                    if (this.props.onVerified) this.props.onVerified();
                    if (this.props.onHide) this.props.onHide();
                    if (this.props.history) {
                        this.props.history.push(`/landing-url/preview/${urlId}`);
                    } else {
                        toast.success("Domain verified successfully.");
                    }
                } else {
                    this.load();
                    toast.info("Details Not Verified. Please Update NS Record And Try Again.");
                }
            })
            .catch((err) => {
                apiError(err);
                this.setState({ loading: false });
            });
    };

    render() {
        const { show, onHide } = this.props;
        const { domainName, ns1, ns2, originalNS, loading, copiedId } = this.state;

        return (
            <Modal show={show} onHide={onHide} size="lg" className="verify-domain-modal" centered>
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <h5>Verify domain</h5>
                        <p>Verify the domain </p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="noteSection nameServnote">
                        <p>
                            <IoInformation className="tooltip-icon" />
                            <span style={{ color: "blue" }}>{domainName || "—"}</span> is not yet active on Cloudflare
                        </p>
                    </div>
                    <div className="verify-domain-content">
                        <div className="verify-domain-content-item pt-2 mb-4" style={{ borderBottom: '1px dashed #ccc' }} >
                            <div className="compHeading">
                                <span className="point">1</span>Log into your Network Solutions Account
                            </div>
                            <Form.Group controlId="verifyModalExistingNS">
                                <Form.Label>Existing Nameserver </Form.Label>
                                <div className="serverBox">
                                    {(originalNS || []).map((ns, index) => (
                                        <span key={index} className="secondaryBadge" variant="secondary">
                                            {ns} 
                                        </span>
                                    ))}
                                </div>
                            </Form.Group>
                        </div>
                        <div className="verify-domain-content-item">
                            <div className="compHeading">
                                <span className="point">2</span>Replace the Cloudflare nameservers
                            </div>
                            <div className="flexForm">
                                <Form.Group>
                                    <Form.Label>Nameserver 1</Form.Label>
                                    <Form.Control disabled type="text" value={ns1} />
                                </Form.Group>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="copy-tooltip-ns1">Copied</Tooltip>}
                                    show={copiedId === "nameserver1"}
                                >
                                    <div className="copyIcon" onClick={() => this.handleCopy("nameserver1", ns1)} role="button" aria-label="Copy">
                                        <PiCopy />
                                    </div>
                                </OverlayTrigger>
                            </div>
                            <div className="flexForm" style={{ marginBottom: '0px' }}>
                                <Form.Group>
                                    <Form.Label>Nameserver 2</Form.Label>
                                    <Form.Control disabled type="text" value={ns2} />
                                </Form.Group>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="copy-tooltip-ns2">Copied</Tooltip>}
                                    show={copiedId === "nameserver2"}
                                >
                                    <div className="copyIcon" onClick={() => this.handleCopy("nameserver2", ns2)} role="button" aria-label="Copy">
                                        <PiCopy />
                                    </div>
                                </OverlayTrigger>
                            </div>

                        </div>
                    </div>
                    {loading ? <Loader /> : null}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="success" onClick={this.verifyDomain}>
                        Verify
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
